import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import CZQUI from 'lib/czqui'
import fxUI from 'lib/wind-ui'
import { RouterConfig } from './RouterConfig'
import festival from './lib/festival'
import VueClipboard from 'vue-clipboard2'
import appInit from './lib/appInit'
import weixin from './lib/weixin'

weixin.createWechatRegisterHref()
festival.initFestivalStyle()

// 是否开启eruda 移动端调试工具
const useEruda = false

Vue.config.debug = true

// 自定义过滤器-日期过滤器-年月日时分秒 转化成  年月日
Vue.filter('dateFilterYMD', function (date) {
	if (date != null) {
		let dateArr = date.split(' ')
		return dateArr[0]
	}
})
Vue.filter('filterFloat', function (v) {
	var temp = v * 1
	return parseFloat(temp.toFixed(4))
})
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(fxUI)
Vue.use(CZQUI)
Vue.use(VueClipboard)
Vue.use(appInit)

if (process.env.NODE_ENV === 'development') {
	Vue.config.devtools = true
} else {
	Vue.config.devtools = false
}

const router = new VueRouter({
	base: '/cldEdi',
	mode: 'history',
	routes: RouterConfig
})

const app = require('./App')
app.router = router

const eruda = function () {
	var script = document.createElement('script')
	script.src = 'https://cdn.bootcss.com/eruda/1.5.5/eruda.min.js'
	document.body.appendChild(script)
	script.onload = function () {
		window.eruda.init()
	}
}
if (useEruda) {
	eruda()
}
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue(app).$mount('#app')

Vue.http.interceptors.push((request, next) => {
	request.headers.set('module', 'supplieredi') // setting request.headers
	next((response) => {
		var sessionstatus = response.headers.map.sessionstatus
		if (sessionstatus !== undefined) {
			window.location.href = 'kickout'
			return false
		}
	})
})




// WEBPACK FOOTER //
// ./src/main.js